export const environment = {
  production: false,
  apiBaseUrl: '/php/login/function.php',
  tenantConfigUrl: '/php/tenant/function.php',
  menuConfigUrl: '/php/food-menu/function.php',
  orderUrl: '/php/food-order-tenant/function.php',
  reportsUrl: '/php/food-order-reporting/function.php',
  adminAuth: '/dummy/admin-user.json',
  logging: true,
  analyticsEnabled: false,
};
